export const reservationConversations = {
  tabs: {
    calls: "Anrufe",
    web: "Web",
    checkins: "Check-ins",
    charges: "Zahlungen",
    notes: "Notizen",
  },
  checkinBadge: {
    allCompleted: "Alle Check-ins abgeschlossen",
    manuallyResolved: "Endgültige Übermittlung manuell durch einen Mitarbeiter abgeschlossen",
    progress: "{done}/{total} Check-ins abgeschlossen",
  },
  banners: {
    limitedMode:
      "Diese Buchung ist nicht für den vollständigen Ablauf eingerichtet. Sie können nur WhatsApp und interne Notizen nutzen.",
    rejectedMode:
      "Die Anfrage wurde abgelehnt. Es stehen nur WhatsApp und interne Notizen zur Verfügung.",
    autoReplying: "Der Agent antwortet automatisch.",
  },
  search: {
    placeholder: "Nach Name, Telefon oder Buchungscode suchen...",
  },
  list: {
    emptyTitle: "Noch keine Konversationen",
    emptyText:
      "Sobald der Gast schreibt oder Sie eine Nachricht senden, erscheint die Konversation hier.",
    noResultsTitle: "Keine Konversationen gefunden",
    noResultsText: "Versuchen Sie einen anderen Namen, eine andere Telefonnummer oder einen anderen Buchungscode.",
    aiActiveTitle: "KI-Agent aktiv",
    markAllRead: "Alle als gelesen markieren",
  },
  conversation: {
    windowTimer: "Nachrichtenfenster: noch {hours} Std.",
    copyPortalCopied: "Link kopiert",
    copyPortalTooltip: "Verwaltungslink kopieren",
    copiedShort: "Kopiert",
    copyLinkShort: "Link kopieren",
    dropToAttach: "Zum Anhängen der Dateien hier ablegen",
    senderBot: "BOT / TEAM",
    senderGuest: "GAST",
    imageAlt: "Gesendetes Bild",
    locationReceived: "Standort erhalten",
    viewFile: "Datei ansehen",
    notSent: "Nicht gesendet",
    sending: "Wird gesendet...",
    emptyTitle: "Noch keine Nachrichten",
    emptyText:
      "Starten Sie die Konversation mit einer Vorlage oder warten Sie, bis der Gast schreibt.",
  },
  mode: {
    ai: "KI",
    manual: "Manuell",
    agentInactiveTooltip:
      "Der KI-Agent ist für diese Unterkunft nicht aktiv. Aktivieren Sie ihn in den Inserat-Einstellungen, damit er automatisch antwortet.",
    agentInactiveChip: "KI-Agent inaktiv",
  },
  composer: {
    predefinedTitle: "Vordefinierte Antworten",
    predefinedEmpty: "Keine vordefinierten Antworten gefunden",
    attachFile: "Datei anhängen",
    inputPlaceholder: "Mit / beginnen, um eine vordefinierte Antwort zu wählen.",
    removeFile: "Datei entfernen",
    fileFallback: "Datei",
  },
  calls: {
    title: "Anrufe zu dieser Buchung",
    none: "Keine Anrufe mit dieser Buchung verknüpft.",
    caller: "Anrufer",
    bookedFromCall: "Aus diesem Anruf gebucht",
    pause: "Pause",
    play: "Abspielen",
    downloadMp3: "MP3 herunterladen",
    noRecording: "Keine Aufzeichnung",
  },
  ota: {
    noData: "Keine Buchungsdaten zum Laden der OTA-Nachrichten.",
  },
  checkins: {
    title: "Check-ins der Buchung",
  },
  charges: {
    title: "Zahlungen der Buchung",
    noData: "Keine Buchungsdaten zum Laden der Zahlungen.",
  },
  notes: {
    title: "Interne Notizen",
    noData: "Keine Buchungsdaten zum Laden der Notizen.",
  },
  time: {
    today: "Heute {time}",
    yesterday: "Gestern {time}",
  },
  guestFallback: "Gast",
  webGuestFallback: "Gast",
  documentFallback: "Dokument",
  location: {
    openInMaps: "In Google Maps öffnen",
    viewCoords: "Koordinaten ansehen ({lat}, {lng})",
  },
  delivery: {
    read: "Gelesen",
    delivered: "Zugestellt",
    queued: "In Warteschlange",
    failed: "Fehlgeschlagen",
    sent: "Gesendet",
  },
  errors: {
    genericSendFail: "Diese Nachricht konnte nicht über WhatsApp gesendet werden.",
  },
  failureShort: {
    paymentIssue: "Zahlungsproblem beim WhatsApp-Konto",
    cannotReceive: "die Nummer kann kein WhatsApp empfangen",
    downloadFailed: "WhatsApp konnte die Datei nicht herunterladen",
    templateMissingData: "fehlende Daten in der Vorlage",
    requirementsNotMet: "die Nachricht erfüllt die Anforderungen von WhatsApp nicht",
  },
  failureTitle: {
    noWhatsapp: "Kein WhatsApp",
    invalidNumber: "Ungültige Nummer",
    notSent: "Nicht gesendet",
  },
  alerts: {
    paymentIssue: "Zahlungsproblem bei WhatsApp",
    whatsappUnavailable: "WhatsApp nicht verfügbar",
    qualityReduced: "Verringerte Qualität der Nummer",
  },
  toast: {
    reactivateNoConv: "Die Konversation zum Reaktivieren konnte nicht ermittelt werden.",
    templateSent: "Vorlage erfolgreich gesendet.",
    reactivateFail: "Die Reaktivierungsvorlage konnte nicht gesendet werden.",
    cannotSendWhatsappTitle: "Senden über WhatsApp nicht möglich",
    invalidPhoneDetail:
      "Die Telefonnummer dieser Buchung ({phone}) ist ungültig. Korrigieren Sie sie unter \"Buchung bearbeiten\", um zu schreiben.",
    noPhoneDetail:
      "Diese Buchung hat keine Telefonnummer. Fügen Sie sie unter \"Buchung bearbeiten\" hinzu, um zu schreiben.",
    sendErrorTitle: "Fehler beim Senden",
    sendErrorDetail: "Die Nachricht konnte nicht gesendet werden",
    errorTitle: "Fehler",
    copyLinkFail: "Der Link konnte nicht kopiert werden",
    agentInactiveTitle: "KI-Agent inaktiv",
    agentInactiveDetail:
      "Für diese Unterkunft ist der KI-Agent nicht aktiv. Aktivieren Sie ihn in den Inserat-Einstellungen.",
    noConvId: "Die Konversation konnte nicht ermittelt werden",
    modeChangeFail: "Der Chat-Modus konnte nicht geändert werden",
    agentUnavailableTitle: "KI-Agent nicht verfügbar",
  },
};
